export default __webpack_public_path__ + "static/media/pt-dropdown.a656044f.webp";